module.exports = __webpack_public_path__ + "static/build-share-102524dcfcfdf40135ba757d85373b42.svg";